import React, { FC, HTMLAttributes } from "react";
import { Images } from "../../../@assets/images";
import {
  ElContactUs,
  ElContactUsContent,
  ElColumn,
  elGapContactUs,
  ElColumnInside,
  ElHeaderTitle,
  ElSubTitle,
  ElBoxSubs,
  ElBoxSubsInside,
  ElHeaderSubTitle,
  ElDetails,
  elPad20,
  elIfranme,
  elMapBox,
  elHasBg,
  elHasBgGreen,
} from "./contact-us.css";
import { Container } from "../../layout";
import { Icons } from "../../icons";
import { cx } from "@linaria/core";
import { elFlexColumn } from "../../../@css-style";
import { ElHeadLine } from "../head-title";

interface IContactUsProps extends HTMLAttributes<HTMLElement> {}

export const ContactUs: FC<IContactUsProps> = ({ children, ...props }) => {
  return (
    <ElContactUs {...props} style={{ backgroundImage: `url(${Images.bgRight})` }}>
      <Container className={elGapContactUs}>
        <ElContactUsContent>
          <ElHeadLine>Contact Us</ElHeadLine>
        </ElContactUsContent>
        <ElContactUsContent>
          <ElColumn className={elMapBox}>
            <ElColumnInside>
              <iframe
                className={elIfranme}
                allowFullScreen
                loading="lazy"
                width={"100%"}
                height={"100%"}
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3966.153130899266!2d106.85090600000001!3d-6.243540899999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69f3bb108797d7%3A0xdec39c99f7e50abe!2sGedung%20Film%20Pesona%20Indonesia!5e0!3m2!1sid!2sid!4v1748692012286!5m2!1sid!2sid"
                title="Wisma LSPPI Jl. Garuda No.28, Mekarsari, Cimanggis,&nbsp;Depok"
                aria-label="Wisma LSPPI Jl. Garuda No.28, Mekarsari, Cimanggis,&nbsp;Depok"
              ></iframe>
            </ElColumnInside>
          </ElColumn>
          <ElColumn className={elFlexColumn}>
            <ElHeaderTitle>Hubungi Kami</ElHeaderTitle>
            <ElSubTitle>Dapatkan informasi lebih lanjut</ElSubTitle>

            <ElColumnInside className={cx(elPad20, elHasBg)}>
              <ElBoxSubs className={""}>
                <Icons icon={"map"} size="3x" />
                <ElBoxSubsInside>
                  <ElHeaderSubTitle>Locations</ElHeaderSubTitle>
                  <ElDetails>Gedung Film, Jl. Letjen M.T. Haryono No.Kav. 47 48, Kota Jakarta Selatan</ElDetails>
                </ElBoxSubsInside>
              </ElBoxSubs>
            </ElColumnInside>

            <ElColumnInside className={cx(elPad20, elHasBgGreen)}>
              <ElBoxSubs className={""}>
                <Icons icon={"envelope"} size="3x" color="#fff" />
                <ElBoxSubsInside>
                  <ElHeaderSubTitle>Email</ElHeaderSubTitle>
                  <ElDetails>dit.aplikasi.kemenekraf@gmail.com</ElDetails>
                </ElBoxSubsInside>
              </ElBoxSubs>
            </ElColumnInside>
          </ElColumn>
        </ElContactUsContent>
      </Container>
    </ElContactUs>
  );
};
